module.exports = __webpack_public_path__ + "img/img_82837_0_59.a89ac584.png";